export const typoPrefix_header = "headerText";
export const typoPrefix_content = "contentText";
